import payouts from 'state/reporting/payouts';

export default {
  payouts,
};
